/* eslint-disable no-param-reassign */
const URL_REG = /(.*?)\.qq.com/ig; // 验证QQ 域名的表达式，不在跨域做跳转
const checkUrlDomain = url => URL_REG.test(url);

export default {
  install: (vue) => {
    // 链接跳转，会做跳转前验证
    vue.prototype.$directTo = (link, options = {}) => {
      if (checkUrlDomain(link)) {
        const { target } = options || '_blank';
        window.open(link, target);
      } else {
        console.error(`当前link${link}不合法`);
      }
    };
  },
};
